import React, { Component } from 'react';
import { Button, cls } from "../../../../packages/components";
import Assets from '../../../../requests/apa/Asset';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';
import logger from 'src/utils/logger/logger';

class ButtonSalir extends Component {
    constructor(props) {
        super(props);
        super(props);
        const region = DeviceStorage.getItem("region");
        this.buttonOnDefault =  Assets.get('LandingPageClaroTv_BotonSecundario_ColorBotonSecundario_Btn_Salir_On', '');
        this.buttonOn = Assets.get(`LandingPageClaroTv_BotonSecundario_ColorBotonSecundario_Btn_Salir_On_${region}`, '') || this.buttonOnDefault;
        this.buttonOffDefault =  Assets.get("LandingPageClaroTv_BotonSecundario_ColorBotonSecundario_Btn_Salir_Off", '');
        this.buttonOff = Assets.get(`LandingPageClaroTv_BotonSecundario_ColorBotonSecundario_Btn_Salir_Off${region}`, '') || this.buttonOffDefault;

        this.state = {
            imageOnError: false,
            imageOffError: false,
            focus: false
        }
    }

    render(){
        const { imageOnError, imageOffError, focus } = this.state;
        const { buttonOn, buttonOff, buttonOnDefault, buttonOffDefault } = this;
        const { goBack } = this.props

        return <Button
                    type="button"
                    variant="primary"
                    className={cls(
                        `focusable`,
                        'btn',
                        `btn-salir`
                    )}
                    onClick={() => {
                        logger.debug("going back");
                        goBack();
                    }}
                    onFocus={() => this.setState({focus: true})}
                    onBlur={() => this.setState({focus: false})}

                >
                    <img src={imageOnError ? buttonOnDefault : buttonOn}
                        onError={imageOnError ? () => {} : () => {
                            this.setState({imageOnError: true})
                        }}
                        style={{display: !focus ? "none" : "block"}}
                    />
                    <img src={imageOffError ? buttonOffDefault : buttonOff}
                        onError={imageOffError ? () => {} : () => {
                            this.setState({imageOffError: true})
                        }}
                        style={{display: focus ? "none" : "block"}}
                    />
                </Button>
    }
}

export default ButtonSalir;



// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/buttons/ButtonSalir.jsx